import React from "react";
import clsx from "clsx";
const FormButton = ({ className, disabled, type, value, onClick, icon }) => {
    return (React.createElement("button", { className: clsx(className, disabled && 'button__submit', !disabled && 'button__submit button__submit--validation'), type: type, onClick: onClick, disabled: disabled },
        icon && React.createElement("i", { className: icon }),
        " ",
        value));
};
export default FormButton;
